// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c3db55c9","455":"fdafc93c","977":"e0a3fd6e"}[chunkId] + ".chunk.js";
};